import { render, staticRenderFns } from "./InputBalance.vue?vue&type=template&id=6a4dbcff&scoped=true&"
import script from "./InputBalance.vue?vue&type=script&lang=js&"
export * from "./InputBalance.vue?vue&type=script&lang=js&"
import style0 from "./InputBalance.vue?vue&type=style&index=0&id=6a4dbcff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4dbcff",
  null
  
)

export default component.exports